export default __webpack_public_path__ + "static/Manufacturing-hero-31a218a94213bcaa2083a6771e983461.png";